import React from 'react';

import { Input } from '@chakra-ui/react';

import { commonFieldStyles } from '../../Form/styles';
import {
  OutlinedFormFieldComponentProps,
  OutlinedFormTextField,
} from '../types';

import { FieldContainer } from './FieldContainer';

export const TextField = ({
  field,
  styles,
}: OutlinedFormFieldComponentProps<OutlinedFormTextField>) => {
  // The outer field owns the border so the inner input can match Form typography.
  const fieldStyles = {
    ...field.styles,
    field: {
      borderColor: commonFieldStyles.borderColor,
      borderRadius: commonFieldStyles.borderRadius,
      _hover: commonFieldStyles._hover,
      _active: commonFieldStyles._active,
      _focusWithin: commonFieldStyles._focus,
      ...field.styles?.field,
    },
  };

  return (
    <FieldContainer
      fieldStyles={fieldStyles}
      isDisabled={field.isDisabled}
      label={field.label}
      styles={styles}
    >
      <Input
        autoComplete="off"
        mt={1}
        h={7}
        p={0}
        border="none"
        borderRadius={0}
        fontSize={commonFieldStyles.fontSize}
        lineHeight="short"
        _hover={{ borderColor: 'transparent' }}
        _active={{ borderColor: 'transparent' }}
        _focus={{ borderColor: 'transparent', boxShadow: 'none' }}
        _focusVisible={{ boxShadow: 'none' }}
        {...styles?.value}
        {...field.styles?.value}
        {...field.inputProps}
        defaultValue={field.defaultValue}
        isDisabled={field.isDisabled}
        name={field.name}
        onChange={field.onChange}
        placeholder={field.placeholder}
        value={field.value}
      />
    </FieldContainer>
  );
};
